import React from 'react'
import { UseFormRegister, FieldValues, Path } from 'react-hook-form'
import { TextareaInput } from '../../../../components/form/inputs/TextareaInput'

interface ListItemData<T> {
  value: string
  fieldName: keyof T
  rows?: number
}

interface ListSectionProps<T extends FieldValues> {
  title: string
  items: ListItemData<T>[]
  isEditing: boolean
  register?: UseFormRegister<T>
}

export const ListSection = <T extends FieldValues>({
  title,
  items,
  isEditing,
  register,
}: ListSectionProps<T>) => {
  return (
    <div className="flex">
      <p className="font-bold text-base mb-1">・</p>
      <div className="flex-1">
        <p className="font-bold text-base mb-1">{title}</p>
        {items.map((item, index) => (
          <div key={index} className="flex">
            <p className="font-bold text-base mb-1">・</p>
            <div className="flex-1">
              <div className="text-sm mb-3">
                {isEditing && register ? (
                  <TextareaInput
                    register={register(item.fieldName as Path<T>)}
                    rows={item.rows || 3}
                  />
                ) : (
                  item.value
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
